<script>
import cloneDeep from "lodash/cloneDeep";
import Modal from "../Modal.vue";
import StartEndTimes from "../StartEndTimes.vue";
import InputField from "@/components/forms/InputField.vue";
import NewHolidays from "@/components/NewHolidays.vue";
import upperFirst from "../methods/upperFirst";

const EditCourseDatesModal = {
    name: "EditCourseDatesModal.vue",
    components: {
        Modal,
        StartEndTimes,
        InputField,
        NewHolidays,
    },
    props: {
        showModal: false,
        course: {
            type: Object,
        },
        time: {
            type: String,
            default: "",
        },
        modalSpinner: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            courseName: "",
            plainStartDate: "",
            plainEndDate: "",
            startDate: null,
            startDateWeekday: "",
            endDate: null,
            endDateWeekday: "",
            holidays: [],
            recurrenceType: "",
            errorStart: "",
            errorEnd: "",
            repetitionType: null,
            errorDate: "",
            errorCourseName: "",
            errorRepetitionType: "",

            start: "",
            end: "",
        };
    },
    methods: {
        setDates(dates) {
            this.plainStartDate = dates.start.plain;
            this.startDate = dates.start.date;
            this.startDateWeekday = dates.start.weekday;
            this.plainEndDate = dates.end.plain;
            this.endDate = dates.end.date;
            this.endDateWeekday = dates.end.weekday;
        },

        validate() {
            this.errorCourseName = (this.courseName === "" || this.courseName === undefined)
                ? "Enter date range name"
                : "";

            return this.errorCourseName === "";
        },

        // eslint-disable-next-line consistent-return
        submitModal() {
            this.$refs.holidaysComponent.emitUpdate();

            const valid = this.validate();

            if (!valid) {
                return false;
            }

            this.$emit("submit", {
                courseName: this.courseName,
                plainStartDate: this.plainStartDate,
                startDate: this.startDate,
                startDateWeekday: this.startDateWeekday,
                plainEndDate: this.plainEndDate,
                endDate: this.endDate,
                endDateWeekday: this.endDateWeekday,
                holidays: this.holidays,
                newHolidays: this.newHolidays,
                repetition: this.repetitionType,
            });
        },

        closeModal() {
            this.$emit("close");
        },

        upperFirst(string) {
            return upperFirst(string);
        },

        submitDelete() {
            this.$emit("delete");
        },

        handleHolidaysUpdate(data) {
            this.newHolidays = data;
        },
    },
    computed: {
        getFormattedHoliday() {
            return this.holidays.map((holiday, holidayIdx) => ({
                start: {
                    plain: holiday.start,
                },
                end: {
                    plain: holiday.end,
                },
                oneDay: holiday.one_day === "Y",
                idx: holidayIdx,
            }));
        },
    },

    mounted() {
        this.courseName = this.course?.name;
        this.plainStartDate = this.course?.start;
        this.startDate = this.course?.startDate;
        this.startDateWeekday = this.course?.startDateWeekday;
        this.plainEndDate = this.course?.end;
        this.endDate = this.course?.endDate;
        this.endDateWeekday = this.course?.endDateWeekday;
        this.holidays = this.course?.holidays;
        this.repetitionType = this.course?.repetition;

        this.start = cloneDeep(this.plainStartDate);
        this.end = cloneDeep(this.plainEndDate);
    },
};

export default EditCourseDatesModal;
</script>

<template>
    <Modal
        :show-modal="showModal"
        :new-header="true"
        :header-options="{
            title: course?.name,
            recurrence: `${upperFirst(course?.repetition)} recurrence`,
            time: time,
        }"
        :show-spinner="modalSpinner"
        @submit-modal="submitModal"
        @close-modal="closeModal"
        @submit-delete="submitDelete"
        submit-text="Save"
        close-text="Delete date range"
        :default-footer="false"
    >

        <h2 class="">Edit date range</h2>

        <div class="d-flex flex-column">
            <InputField
                labelText="Date range name"
                placeholder="Enter a name (e.g. Autumn Camp)"
                :required="true"
                v-model="courseName"
                :value="courseName"
                :error="errorCourseName"
            />
        </div>

        <div class="mt-3">
            <StartEndTimes
                data-test-id="advanced-start-end-times"
                @change="setDates"
                parent-page="mp"
                :start="start"
                :end="end"
                :index="0"
                :errors="{
                    startDate: errorStart,
                    endDate: errorEnd
                }"
            />
            <div v-if="errorDate">
                <div class="error-text" data-test="validation-error">{{ errorDate }}</div>
            </div>
        </div>

        <h2 class="">Edit holidays</h2>

        <div class="">
            <NewHolidays
                ref="holidaysComponent"
                start-holiday-label="Holiday start date (optional)"
                end-holiday-label="Holiday end date (optional)"
                :start-date="start"
                :end-date="end"
                :default-holidays="getFormattedHoliday"
                @updated="handleHolidaysUpdate"
            />
        </div>
    </Modal>
</template>

<style scoped>
h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2.25rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
}
</style>
